import { LoadingButton } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { useContent } from "../../content/useContent";
import { Colors } from "../../theme/colors";
import { darkModeField } from "../../theme/darkModeInput";
import FormikInput from "../Form/FormikInput";

const classes = {
  description: {
    lineHeight: "70px",
    fontSize: "32px",
    fontWeight: "700",
    color: Colors.white,
  },

  forgetPassword: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "12px 0",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
      textDecorationColor: Colors.secondary,
    },
  },
  btn: {
    height: "66px",
    width: "100%",
    fontWeight: "600",
    fontSize: "18px",
  },
  field: { ...darkModeField, margin: "0" },
};

type IProps = {
  formik: any;
  loading: boolean;
  setShowResetEmail: React.Dispatch<React.SetStateAction<boolean>>;
};

const ResetEmailForm: React.FC<IProps> = ({
  formik,
  loading,
  setShowResetEmail,
}) => {
  const { login } = useContent().pages;

  return (
    <>
      <Typography
        variant="h1"
        component="h1"
        color="secondary"
        sx={classes.description}
      >
        {login.forgot}
      </Typography>
      <Typography
        variant="body2"
        component="p"
        color="secondary"
        sx={{ mb: 4, fontSize: 16 }}
      >
        {login.forgotDescription}
      </Typography>

      <FormikInput
        formik={formik}
        name="email"
        label={login.email}
        sx={classes.field}
      />
      <Typography
        onClick={() => setShowResetEmail(false)}
        variant="body2"
        component="p"
        color="secondary"
        sx={classes.forgetPassword}
      >
        {login.log}
      </Typography>

      <LoadingButton
        variant="contained"
        color="secondary"
        onClick={formik.handleSubmit}
        loading={loading}
        sx={classes.btn}
      >
        {login.send}
      </LoadingButton>
    </>
  );
};

export default ResetEmailForm;
